var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDouyin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_114)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_275_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66667C0 1.19391 1.19391 0 2.66667 0H13.3333C14.8061 0 16 1.19391 16 2.66667V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13175 7.4328V7.22602C3.06139 7.2174 2.99103 7.21165 2.91786 7.21165C2.04539 7.21165 1.33333 7.93541 1.33333 8.8286C1.33333 9.37428 1.6007 9.85965 2.0088 10.1526C1.74424 9.86252 1.58382 9.47767 1.58382 9.05262C1.58663 8.17091 2.27617 7.45291 3.13175 7.4328Z",
    fill: "#00F2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1684 9.78494C3.5568 9.78494 3.87483 9.46902 3.8889 9.07556V5.55735H4.51935C4.50527 5.48555 4.49963 5.41088 4.49963 5.33333H3.63842V8.85154C3.62435 9.24501 3.30631 9.56093 2.91792 9.56093C2.7969 9.56093 2.68151 9.52933 2.583 9.47477C2.71528 9.66431 2.92917 9.78494 3.1684 9.78494Z",
    fill: "#00F2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69833 6.75215V6.55685C5.45912 6.55685 5.23396 6.48505 5.04539 6.35869C5.21425 6.55398 5.44223 6.69471 5.69833 6.75215Z",
    fill: "#00FAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04842 6.35877C4.86549 6.14337 4.75292 5.86478 4.75292 5.55748H4.52213C4.58405 5.89063 4.77824 6.17783 5.04842 6.35877Z",
    fill: "#FF0050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91788 8.08754C2.51822 8.08754 2.19456 8.41782 2.19456 8.82564C2.19456 9.10998 2.35217 9.35409 2.58295 9.47759C2.49852 9.35696 2.44504 9.20762 2.44504 9.04678C2.44504 8.63896 2.76871 8.30869 3.16835 8.30869C3.24153 8.30869 3.31471 8.32017 3.38226 8.34314V7.44707C3.3119 7.43846 3.24153 7.43272 3.16835 7.43272C3.15711 7.43272 3.14301 7.4328 3.13175 7.4328L3.13177 8.12199C3.06422 8.09903 2.99386 8.08754 2.91788 8.08754Z",
    fill: "#FF004F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69833 6.75215L5.69847 7.43567C5.25099 7.43567 4.84008 7.2892 4.50234 7.0422V8.82572C4.50234 9.71604 3.7931 10.4427 2.91781 10.4427C2.58008 10.4427 2.26767 10.3335 2.01156 10.1497C2.30145 10.4656 2.71236 10.6667 3.1711 10.6667C4.04359 10.6667 4.75564 9.94293 4.75564 9.04973V7.26622C5.09337 7.51322 5.50709 7.65969 5.95178 7.65969V6.78085C5.86453 6.77798 5.77995 6.76938 5.69833 6.75215Z",
    fill: "#FF004F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50234 8.82572V7.0422C4.84006 7.2892 5.25378 7.43567 5.69847 7.43567L5.69833 6.75215C5.4394 6.69471 5.21426 6.55398 5.04539 6.35869C4.7752 6.18062 4.58122 5.8935 4.52213 5.55748H3.89144V9.07568C3.87736 9.46915 3.55933 9.78507 3.17095 9.78507C2.92891 9.78507 2.715 9.66444 2.58554 9.47776C2.35475 9.35426 2.19715 9.10728 2.19715 8.82581C2.19715 8.41799 2.52081 8.08772 2.92046 8.08772C2.99363 8.08772 3.06681 8.0992 3.13435 8.12217V7.43289C2.27876 7.45299 1.58923 8.17101 1.58923 9.04696C1.58923 9.47202 1.74965 9.85973 2.01421 10.1469C2.27032 10.3307 2.58554 10.4399 2.92046 10.4399C3.79011 10.4428 4.50234 9.71604 4.50234 8.82572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81435 6.27627H7.40519V6.88974H6.92992V7.30728H7.40519V8.15843L6.92992 8.22909V8.66912L7.40519 8.59845V9.32756C7.40519 9.38537 7.35797 9.43355 7.30132 9.43355H6.95825V9.85109H7.47128C7.66013 9.85109 7.81435 9.6937 7.81435 9.501V8.53744L8.22982 8.4732V8.03317L7.81435 8.0974V7.3105H8.22982V6.89296H7.81435V6.27627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1316 6.27627H9.72552V8.45714L8.37839 8.57597V9.01601L9.72552 8.90038V9.88H10.1316V8.86184L10.547 8.82329V8.38327L10.1316 8.42181V6.27627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51446 6.76148L8.54817 6.58483V7.02807L9.51446 7.20151V6.76148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51446 7.67669L8.54817 7.50005V7.94328L9.51446 8.11993V7.67669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8672 7.49374L13.9301 7.15327H13.4989L13.4328 7.49374H12.306L12.2557 7.15327H11.8213L11.8748 7.49374H11.0565V7.90164H14.6667V7.49374H13.8672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5534 6.56534H13.1842L13.1149 6.27627H12.583L12.6523 6.56534H11.1698V6.97003H14.5534V6.56534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9963 8.2005H11.7269C11.5381 8.2005 11.3838 8.35789 11.3838 8.55059V9.50453C11.3838 9.69724 11.5381 9.85462 11.7269 9.85462H13.9963C14.1851 9.85462 14.3394 9.69724 14.3394 9.50453V8.55059C14.3394 8.35789 14.1883 8.2005 13.9963 8.2005ZM11.8717 8.57951H13.8546C13.9113 8.57951 13.9585 8.62768 13.9585 8.6855V8.85572H11.771V8.6855C11.7678 8.62446 11.815 8.57951 11.8717 8.57951ZM13.8546 9.47884H11.8717C11.815 9.47884 11.7678 9.43066 11.7678 9.37285V9.1994H13.9554V9.37285C13.9554 9.43066 13.9113 9.47884 13.8546 9.47884Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_275_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouyin);
export default __webpack_public_path__ + "static/media/douyin.c75ab5cc8442be7bddfedbc65888559a.svg";
export { ForwardRef as ReactComponent };